<script lang="ts">
    import DotIcon from "../icons/DotIcon.svelte";

    export let dotsLength: number;
    export let currentDot: number;
    export let onDotClick: (dot: number) => void;
</script>

<div class="dotsContainer">
    {#each new Array(dotsLength) as dot, i}
        {#if i === currentDot}
            <div class="dot">
                <DotIcon height="0.5rem" fill=""/>
            </div>
        {:else}
            <div class="dot" on:click={onDotClick(i)}>
                <DotIcon height="0.5rem" fill="#e3e3e3"/>
            </div>
        {/if}
    {/each}
</div>

<style>

    .dotsContainer {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 1em;
    }

    .dot {
        padding: 0 3px;
        cursor: pointer;
    }

</style>